// TODO: add flow types

import spaCategory from './factories/spaCategory';

export default spaCategory('fitness', 'fitness');
